import { useState, ReactNode } from 'react'

type FormInputProps = {
  placeholder: string
  label?: ReactNode
  value: string
  onChange: (value: string) => void
  type?: string
  delay?: number
  error?: boolean
  disabled?: boolean
}

export function FormInput({
  placeholder,
  label,
  value,
  onChange,
  type = 'text',
  delay = 0,
  error = false,
  disabled = false
}: FormInputProps) {
  const [focused, setFocused] = useState(false)
  const isPassword = type === 'password'

  return (
    <div style={delay ? { animationDelay: `${delay}ms` } : undefined}>
      {label && <label className="enrollment-field-label">{label}</label>}
      <div className="relative">
        <input
          type={type}
          value={value}
          onChange={e => onChange(e.target.value)}
          disabled={disabled}
          onFocus={() => setFocused(true)}
          onBlur={() => setFocused(false)}
          placeholder={!focused ? placeholder : ''}
          className={`enrollment-field-control ${isPassword ? 'enrollment-field-control--icon-right' : ''} ${error ? 'enrollment-field-control--error' : ''}`}
          style={{
            padding: isPassword ? '14px 40px 14px 16px' : '14px 16px'
          }}
        />
        {isPassword ? (
          <svg
            className="pointer-events-none absolute right-3 top-1/2 h-4 w-4 -translate-y-1/2 text-gray-light"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z"
            />
          </svg>
        ) : null}
      </div>
    </div>
  )
}
